import Vue from 'vue'
import contractApi from '@/api/contract.api'
import fileApi from '@/api/file.api'
import { fileType } from '@/constants'

const state = {
  contracts: {},
  loadedByProject: {}
}


const getters = {
  contractsByProject: (state) => (projectId) => {
    return Object.values(state.contracts).filter(contract => contract.projectId === projectId)
  },

  contractsByProjectLoaded: (state) => (projectId) => {
    return state.loadedByProject[projectId] === true
  },

  contractById: (state) => (id) => {
    return state.contracts[id] || null
  }
}


const actions = {
  async loadContractsByProject ({ commit, rootState }, projectId) {
    const response = await contractApi.getContracts(rootState.tenant.current, projectId)
    commit('SET_CONTRACTS', { projectId, contracts: response.data })
  },

  async loadContractById ({ commit, rootState }, { id, projectId }) {
    const response = await contractApi.getContract(rootState.tenant.current, projectId, id)
    commit('SET_CONTRACT', response.data)
    return response.data
  },

  // async loadContractByContractData ({ rootState }, contractData) {
  //   const response = await contractApi.getContract(rootState.tenant.current, contractData.projectId, contractData.id)
  //   return response.data
  // },
  //
  // async updateContractByContractData ({ commit }, contractData) {
  //   commit('UPDATE_CONTRACT', contractData)
  // },

  async loadAndUpdateContract ({ commit, rootState }, entityData) {
    const response = await contractApi.getContract(rootState.tenant.current, entityData.projectId, entityData.entityId)
    commit('UPDATE_CONTRACT', response.data)
    return response.data
  },

  async uploadContractFile ({ rootState }, file) {
    const projectId = rootState.project.currentId
    const response = await fileApi.uploadFile(rootState.tenant.current, projectId, fileType.contract, file)
    return response.data.id
  },

  async createContract ({ commit, rootState }, contract) {
    const response = await contractApi.createContract(rootState.tenant.current, contract.projectId, contract)
    commit('CREATE_CONTRACT', response.data)
    return response.data
  },

  async putContract ({ commit, rootState }, contract) {
    const response = await contractApi.putContract(rootState.tenant.current, contract.projectId, contract.id, contract)
    commit('UPDATE_CONTRACT', response.data)
  },

  async setContractStatus ({ commit, rootState }, { id, projectId, status }) {
    const response = await contractApi.setContractStatus(rootState.tenant.current, projectId, id, status)
    commit('UPDATE_CONTRACT', response.data)
  },

  async deleteContract ({ commit, rootState }, { id, projectId }) {
    await contractApi.deleteContract(rootState.tenant.current, projectId, id)
    commit('DELETE_CONTRACT', id)
  },

  async getContractPdf ({ rootState }, { id, projectId }) {
    const response = await contractApi.getContractPdf(rootState.tenant.current, projectId, id)
    return response.data
  }
}


const mutations = {
  SET_CONTRACTS (state, { projectId, contracts }) {
    state.contracts = {}
    Vue.set(state.loadedByProject, projectId, true)

    for (const contract of contracts) {
      Vue.set(state.contracts, contract.id, contract)
    }
  },

  SET_CONTRACT (state, contract) {
    Vue.set(state.contracts, contract.id, contract)
  },

  CREATE_CONTRACT (state, contract) {
    Vue.set(state.contracts, contract.id, contract)
  },

  UPDATE_CONTRACT (state, contract) {
    Vue.set(state.contracts, contract.id, contract)
  },

  DELETE_CONTRACT (state, id) {
    Vue.delete(state.contracts, id)
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
